import { BadgeContainer, BadgeForm, BadgeTitle } from './ManagerBadge.styles'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import { Button, TextField } from '@mui/material'
import { useCallback, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { selectBadgeStatus, selectLoading } from '../../PendingReceivementsSelectors'
import { BadgeStatus } from '../../PendingReceivementsTypes'
import { actions } from '../../PendingReceivementsState'
import { useHistory, useParams } from 'react-router-dom'

interface Imputs {
  badge: string
}

interface UrlParams{
  receivementId: string
}

export const ManagerBadge: React.FC = () => {
  const params = useParams<UrlParams>()
  const history = useHistory()
  const dispatch = useDispatch()
  const loading = useSelector(selectLoading)
  const statusBadge = useSelector(selectBadgeStatus)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Imputs>()

  const onSubmit = useCallback(async (data: Imputs) => {
    dispatch(actions.validateSupervisorBadge(data.badge))
  }, [dispatch])

  useEffect(() => {
    if (statusBadge === BadgeStatus.APROVED) {
      history.push(`/pending-receivement/${params.receivementId}/conference`)
    }
  }, [statusBadge, history, params])

  return (
    <BadgeContainer>
      <BadgeTitle data-testid='manager-badge-title'>
        Insira o crachá do Gestor de Estoque antes de prosseguir
      </BadgeTitle>
      <PersonOutlineIcon color='error'/>
      <BadgeForm onSubmit={handleSubmit(onSubmit)}>
        <TextField
          {...register('badge', { required: 'Campo obrigatório!' })}
          error={!!errors.badge}
          helperText={errors?.badge?.message}
          size='small'
          label='Crachá'
          placeholder='Crachá do Gestor'
          type='password'
          autoFocus
          inputProps={{ 'data-testid': 'manager-badge-input' }}
        />
        <Button variant='contained' color='success' type='submit' disabled={loading} data-testid='validate-badge-button'>
          VALIDAR
        </Button>
      </BadgeForm>
    </BadgeContainer>
  )
}
